var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSnow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2222,
    cy: 21.4437,
    rx: 1.1187,
    ry: 1.08039,
    fill: "#E2EDF8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.4175,
    cy: 24.8196,
    rx: 1.1187,
    ry: 1.08039,
    fill: "#E2EDF8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.105,
    cy: 27.4529,
    rx: 1.1187,
    ry: 1.08039,
    fill: "#E2EDF8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1714,
    cy: 22.5242,
    rx: 1.1187,
    ry: 1.08039,
    fill: "#E2EDF8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.0542,
    cy: 19.0804,
    rx: 1.1187,
    ry: 1.08039,
    fill: "#E2EDF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.35 9.04C22.67 5.59 19.64 3 16 3C13.11 3 10.6 4.64 9.35 7.04C6.34 7.36 4 9.91 4 13C4 16.31 6.69 19 10 19H23C25.76 19 28 16.76 28 14C28 11.36 25.95 9.22 23.35 9.04Z",
    fill: "#E2EDF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSnow);
export default __webpack_public_path__ + "static/media/icon-snow.75f589d6c27b5bc87a6895f6e18b56e1.svg";
export { ForwardRef as ReactComponent };